// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".creditCode_gzSyx {padding-top:15px;padding-bottom:15px;--tw-text-opacity:1;color:rgba(247, 79, 100, 1);color:rgba(247, 79, 100, var(--tw-text-opacity));background:#ff0\n}.creditCode_gzSyx .message_t9dux {width:100%;justify-content:center\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"creditCode": "creditCode_gzSyx",
	"message": "message_t9dux"
};
module.exports = ___CSS_LOADER_EXPORT___;
